import { useCallback } from 'react';

import { ModuleType, useLayout } from '@vimeo/clip-ui/hooks/use-layout';

/**
 * Hook to manage the state and actions for the Event Action Bar module.
 * @param { isInteractionToolsEnabled } - Optional flag to enable interaction tools.
 * @returns An object containing action bar display configuration, handlers, and a flag indicating if the action bar should be shown.
 */
export const useEventActionBarModule = ({
  isInteractionToolsEnabled,
}: {
  isInteractionToolsEnabled?: boolean;
}) => {
  const { activeSideModule, onActiveDrawerModuleChange } = useLayout();

  const toggleSideModule = useCallback(
    (module: ModuleType) => {
      onActiveDrawerModuleChange(activeSideModule === module ? '' : module);
    },
    [activeSideModule, onActiveDrawerModuleChange],
  );

  const onJoinConversationClick = useCallback(() => {
    toggleSideModule('LIVE_TOOLS');
  }, [toggleSideModule]);

  const actionBarDisplayConfig = {
    showLiveTools: isInteractionToolsEnabled,
  };

  const actionBarHandlers = {
    onJoinConversationClick,
  };

  const shouldShowActionBar = Object.values(actionBarDisplayConfig).some((item) => Boolean(item));

  return { actionBarDisplayConfig, actionBarHandlers, shouldShowActionBar };
};
